import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FilterInterface, ProductCategories, ProductSections} from '../../interfaces/filter.interface';
import {Store} from '@ngrx/store';
import {SelectProductCategories, SelectProductSections} from '../../store/actions/filter.actions';
import {first} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {SearchFilterService} from '../../services/search-filter.service';

@Component({
  selector: 'app-product-sections-filter',
  templateUrl: './product-sections-filter.component.html',
  styleUrls: ['./product-sections-filter.component.scss']
})
export class ProductSectionsFilterComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();

  productSectionsSelected: ProductSections = {};

  constructor(private store: Store<{ filter: FilterInterface }>, private searchFilterService: SearchFilterService) {
  }

  ngOnInit(): void {
    this.store.select('filter').subscribe((data) => {
      this.productSectionsSelected = {...data.tags.productSections};
    });
    const resetFilter = this.searchFilterService.resetFilters$.subscribe((reset) => {
      if (reset) {
        this.productSectionsSelected = {};
        this.store.dispatch(SelectProductSections(this.productSectionsSelected));

      }
    });
    // this.subscriptions.add(resetFilter);
  }

  handleProductSectionsSelected(productSections: string): void {
    this.productSectionsSelected[productSections] = !this.productSectionsSelected[productSections];
    //this.productSectionsEvent.emit(this.productSectionsSelected);
    this.store.dispatch(SelectProductSections(this.productSectionsSelected));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
